document.addEventListener('DOMContentLoaded', function() {
    const videoLinks = document.querySelectorAll('.js-video-dialog');
    
    if (videoLinks.length) {
      videoLinks.forEach(link => {
        const dialogId = link.getAttribute('data-dialog-id');
        const videoDialog = document.getElementById(dialogId);
        const videoPlayer = videoDialog.querySelector('iframe');
        const closeButton = videoDialog.querySelector('.video-dialog-close');
    
        function openDialog(videoUrl) {
          videoPlayer.src = videoUrl;
          videoDialog.classList.add('show');
          document.body.style.overflow = 'hidden';
        }
    
        function closeDialog() {
          videoDialog.classList.remove('show');
          videoPlayer.src = '';
          document.body.style.overflow = '';
        }
    
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const videoUrl = link.getAttribute('href');
          openDialog(videoUrl);
        });
    
        closeButton.addEventListener('click', closeDialog);
        
        videoDialog.querySelector('.video-dialog-backdrop').addEventListener('click', closeDialog);
      });
    }
});